import axios from 'axios'
import { mapGetters } from 'vuex'
import { MaximizeIcon } from 'vue-feather-icons'

import QrModal from '@/vcs/_shared/modals/QrModal.vue'
import PhysicalQrReaderModal from '@/vcs/_shared/modals/PhysicalQrReaderModal.vue'
import PickupInfoModal from './PickupInfoModal.vue'
import PickupCompleteModal from './PickupCompleteModal.vue'
import LogoMain from '@/vcs/_shared/LogoMain.vue'
import PhonePrefixSelect from '@/vcs/_shared/PhonePrefixSelect.vue'
import { eventBus } from '@/vcs/_shared/eventBus'

export default {
  name: 'Pickup',
  components: {
    MaximizeIcon,
    QrModal,
    LogoMain,
    PhonePrefixSelect,
    PhysicalQrReaderModal
  },
  data: function () {
    return {
      phonePrefix: '48',
      phone: '',
      collectionKey: '',
      userEmail: ''
    }
  },
  computed: {
    ...mapGetters({
      deviceId: 'getDeviceId',
      cp: 'getCurrentCp'
    })
  },
  mounted() {
    this.addEventBusListener()
    this.$store.commit('startSessionTimer')
    document.addEventListener('click', this.$clickListener)
    eventBus.$emit('refresh-token-via-websockets')
    console.log(this.cp)
  },
  beforeDestroy() {
    this.removeEventBusListener()
  },
  watch: {
    phonePrefix: function () {
      this.emitEvent()
    },
    phone: function () {
      this.emitEvent()
    },
    collectionKey: function () {
      this.emitEvent()
    },
    userEmail: function () {
      this.emitEvent()
    }
  },
  methods: {
    emitEvent() {
      eventBus.$emit('refresh-token-via-websockets')
    },
    addEventBusListener() {
      eventBus.$on('pass-qr-reader-event-to-pickup', this.processQrData)
    },
    removeEventBusListener() {
      eventBus.$off('pass-qr-reader-event-to-pickup', this.processQrData)
    },
    openQrModal() {
      // if (this.$dev) {
      //   this.processQrData('{"phone": null, "phone_prefix": null, "collection_key": "123456", "user_email": "test@test.pl"}')
      //   return
      // }
      this.$store.commit('modal/open', {
        cmp: QrModal,
        size: 'full',
        // callback: this.processQrData,
        disableRedirect: true
      })
    },
    openPhysicalQrReaderModal() {
      this.$store.commit('modal/open', {
        cmp: PhysicalQrReaderModal,
        size: 'popup slightly-higher',
        callback: this.processQrData,
        disableRedirect: true
      })
    },
    openPickupInfoModal() {
      this.$store.commit('modal/open', {
        cmp: PickupInfoModal,
        size: 'full'
      })
    },
    openPickupCompleteModal(boxId = '') {
      this.$store.commit('modal/open', {
        cmp: PickupCompleteModal,
        size: 'full',
        data: { boxId }
      })
    },
    processQrData(data) {
      // INFO: data = '{"phone": null, "phone_prefix": null, "collection_key": "123456", "user_email": "test@test.pl"}'

      // this.$airbrake.notify({
      //   error: new Error(`processQrData`),
      //   context: { component: 'PWA TABLET' },
      //   params: {
      //     response: data
      //   }
      // })

      let dataParsed
      try {
        dataParsed = JSON.parse(data)
      } catch (e) {
        this.$errorHumanized(null, `QR does not contain valid data: ${data}`)
        return
      }

      if (dataParsed.phone_prefix) {
        // INFO: Only update when is not null, because there is no visual change in prefix, I need to add this
        this.phonePrefix = dataParsed.phone_prefix
      }
      this.phone = dataParsed.phone || ''
      this.collectionKey = dataParsed.collection_key || ''
      this.userEmail = dataParsed.user_email || ''
      this.collect()
    },
    onPrefixSelected(prefix) {
      this.phonePrefix = prefix.substr(1) // removing `+` sign
    },
    collect() {
      // if (this.$dev) {
      //   this.openPickupCompleteModal('8ed6e096-17fb-4518-a879-9ea2629934c1')
      //   return
      // }

      if (!this.collectionKey || (!this.userEmail && !(this.phone && this.phonePrefix))) {
        this.$errorHumanized(null, this.$t('error.fillPackageInfo'))
        return
      }

      this.$blockUI()
      axios({
        method: 'put',
        url: `collection_points/${this.deviceId}/collect`,
        params: {
          phone_prefix: this.phonePrefix,
          phone: this.phone,
          collection_key: this.collectionKey,
          user_email: this.userEmail
        }
      })
        .then((response) => {
          this.openPickupCompleteModal(response.data.boxId)
        })
        .catch((error) => {
          console.log('collect error', error.response)
          let errorResponse = (error || {}).response || {}

          if (errorResponse.status == '404') {
            this.$errorHumanized(null, this.$t('error.incorrectData'))
          } else {
            let errorCode = Object.values(((errorResponse || {}).data || {}).errors || {})

            if (errorCode == 'dr:2') {
              this.$errorHumanized(null, this.$t('error.dr2'))
            } else if (errorCode == 'dr:16') {
              this.$errorHumanized(null, this.$t('error.dr16'))
            } else {
              this.$errorHumanized(error)
            }
          }
        })
        .finally(() => {
          this.$unblockUI()
        })
    },
    // utils
    focusEmail() {
      this.phone = ''
      this.$slideUp()
      this.emitEvent()
    },
    focusPhone() {
      this.userEmail = ''
      this.$slideUp()
      this.emitEvent()
    },
    focusCollectionKey() {
      this.$slideUp()
      this.emitEvent()
    }
  }
}
